import { render, staticRenderFns } from "./GameTable.vue?vue&type=template&id=a76b4cea&scoped=true&"
import script from "./GameTable.vue?vue&type=script&lang=js&"
export * from "./GameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76b4cea",
  null
  
)

export default component.exports